// extracted by mini-css-extract-plugin
module.exports = {"logoImage":"header_logo_image-module__logoImage--1F7J8"};